import { render } from "./ProformaNueva.vue?vue&type=template&id=36ece4f9&scoped=true"
import script from "./ProformaNueva.vue?vue&type=script&lang=js"
export * from "./ProformaNueva.vue?vue&type=script&lang=js"

import "./ProformaNueva.vue?vue&type=style&index=0&id=36ece4f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ece4f9"]])

export default __exports__